// Deterministic color assignment for treemap tiles.
// Palette: "Tableau 10" — the restrained, professional categorical palette
// (de-saturated vs. "Crayola bright"), balanced warm/cool, easy on the eyes
// and reads well on the dark canvas with white labels.

const PALETTE = [
  '#4e79a7', // blue
  '#f28e2b', // orange
  '#e15759', // red
  '#76b7b2', // teal
  '#59a14f', // green
  '#edc948', // yellow
  '#b07aa1', // purple
  '#ff9da7', // pink
  '#9c755f', // brown
  '#bab0ac', // gray
];

function hashString(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Base block color keyed by name, stable across renders. */
export function colorForName(name: string): string {
  return PALETTE[hashString(name.toLowerCase()) % PALETTE.length];
}

/**
 * Tile background. Directories use the full saturated color; files are dimmed
 * so the eye is drawn to space-hungry folders first.
 */
export function tileBackground(name: string, isDir: boolean): string {
  const base = colorForName(name);
  return isDir ? base : `${base}66`; // 40% alpha for files
}
